import * as GetInvestorDeckTypes from 'src/actions/investor-deck/get/Types';
import { GetInvestorDeckAction, GetInvestorDeckSuccess } from 'src/actions/investor-deck/get/GetInvestorDeck.actions';
import InvestorDeck from 'src/entities/InvestorDeck';

export interface GetInvestorDeckState {
  investorDeck?: InvestorDeck;
  loading: boolean;
  error: boolean;
  errorMessage: {};
}

const initialState: GetInvestorDeckState = {
  loading: false,
  error: false,
  errorMessage: {}
};

export function GetInvestorDeckReducer(
  state: GetInvestorDeckState = initialState,
  action: GetInvestorDeckAction
): GetInvestorDeckState {

  switch (action.type) {
    case GetInvestorDeckTypes.GET_INVESTOR_DECK_ATTEMPT:
      return {...state, investorDeck: undefined, loading: true, error: false};
    case GetInvestorDeckTypes.GET_INVESTOR_DECK_SUCCESS:
      const investorDeck: InvestorDeck = (action as GetInvestorDeckSuccess).payload;
      return {...state, investorDeck: investorDeck, loading: false, error: false};
    case GetInvestorDeckTypes.GET_INVESTOR_DECK_FAILURE:
      return {...state, investorDeck: undefined, loading: false, error: true};
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/investor-deck/GetInvestorDeckReducer.tsx